import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {coloursV2, darken, elementSize, spacing} from '@fo/shared/styles/variables';

export default {
  componentWrapper: css`
    label: navigationMobile__componentWrapper;
    position: relative;
    width: 100%;
    display: block;
    ${mq(Breakpoints.DESKTOP)} {
      display: none;
    }
  `,
  topBar: css`
    label: navigationMobile__topBar;
    display: flex;
    align-items: center;
    padding: ${spacing.XXS};
    background-color: ${coloursV2.background.white};
    border-bottom: 1px solid ${darken(coloursV2.background.lightGray)};
    z-index: 899;
  `,
  logoContainer: css`
    label: navigationMobile__logoContainer;
    flex-grow: 1;
  `,
  logo: css`
    label: navigationMobile__logo;
    height: 4rem;
    vertical-align: middle;
  `,
  hamburgerContainer: css`
    label: navigationMobile__hamburgerContainer;
    flex-shrink: 1;
    margin-right: 0.2rem;
  `,
  hamburger: css`
    display: flex;
    justify-content: center;
    align-items: center;
    && {
      width: 4rem;
      height: 4rem;
      padding: 0;
    }
  `,
  ctaButtonContainer: css`
    label: navigationMobile__ctaButtonContainer;
    flex-shrink: 1;
    margin-right: ${spacing.XXS};
  `,
  mainBar: (isMenuOpen: boolean): string => css`
    label: navigationMobile__mainBar;
    position: absolute;
    ${isMenuOpen ? 'display: flex' : 'display: none'};
    flex-direction: column;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: ${coloursV2.background.white};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
    z-index: 898;
  `,
  mainBarContents: css`
    label: navigationMobile__mainBarContents;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: ${elementSize.container.XL};
    padding: 0 ${spacing.S};
    height: 11rem;
  `,
  sectionsContainer: (isOpen: boolean): string => css`
    label: navigationMobile__sectionsLabelsContainer;
    display: flex;
    flex-direction: column;
    ${!isOpen &&
    css`
      border-bottom: 1px solid ${darken(coloursV2.background.lightGray)};
    `}
  `,
  sectionLabelTrigger: (isHighlighted?: boolean): string => css`
    label: navigationMobile__sectionLabelTrigger;
    display: flex;
    justify-content: space-between;
    padding: ${spacing.XS};
    letter-spacing: ${spacing.LETTER_SPACING_TIDE_XS};
    border-radius: unset;
    &:active {
      transform: none;
    }
    ${isHighlighted &&
    css`
      background-color: ${coloursV2.background.lightGray};
    `}
  `,
  sectionsContentsWrapper: css`
    label: navigationMobile__sectionsContentsWrapper;
    position: absolute;
    display: flex;
    justify-content: center;
    top: 100%;
    left: 0;
    width: 100%;
    min-height: 34rem;
    background-color: ${coloursV2.background.white};
    box-shadow: 0px 4px 85px rgba(0, 0, 0, 0.025);
    z-index: 897;
  `,
  alternativeJourney: css`
    label: navigationMobile__alternativeJourney;
    display: flex;
    justify-content: space-between;
    padding: ${spacing.XS};
    border-radius: unset;
    background-color: ${coloursV2.background.lightGray};
  `,
  loginContainer: css`
    label: navigationMobile__loginContainer;
    background-color: ${coloursV2.background.white};
  `,
  closeMenuArea: css`
    label: navigationMobile__closeMenuArea;
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 896;
  `,
};
